import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { nanoid } from '@reduxjs/toolkit';



export interface Transaction {
  id: string;
  date: string;
  amount: number;
  from: string;
  to: string;
  result: number;
}

interface CurrencyState {
  transactions: Transaction[];
}

const initialState: CurrencyState = {
  transactions: [],
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    addTransaction: (
      state,
      action: PayloadAction<Omit<Transaction, 'id' | 'date'>>
    ) => {
      state.transactions.push({
        id: nanoid(),
        date: new Date().toISOString(),
        ...action.payload,

      });
      
    },

    deleteTransaction: (state, action:PayloadAction<string>) => {

      state.transactions = state.transactions.filter((t)=>t.id !== action.payload)

    },

    clearTransactions: (state) =>{
      state.transactions = []
    }
    
  },
});

export const { addTransaction, clearTransactions, deleteTransaction } = currencySlice.actions;

export default currencySlice.reducer;
